import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

const user = {}
const apiToken = {}
const currentDate = {}
const today = new Date();

const store = new Vuex.Store({
	state: {
		user: null,
		apiToken: null,
		globalDate: today.getFullYear() + "-" + pad((today.getMonth() + 1), 2) + "-" + pad(today.getDate(), 2)
	},
	getters: {
		user: state => state.user,
		apiToken: state => state.apiToken,
		globalDate: state => state.globalDate
	},
	mutations: {
		initialiseStore(state) {
			// Check if the ID exists
			if(localStorage.getItem('store')) {
				this.replaceState(
					Object.assign(state, JSON.parse(localStorage.getItem('store')))
				);
			}
		},
		updateUser(state, user) {
			state.user = user;
		},
		updateAPIToken(state, apiToken) {
			state.apiToken = apiToken;
		},
		updateGlobalDate(state, globalDate){
			state.globalDate = globalDate;
		},
		resetStore(state) {
			state.user = null;
			state.apiToken = null;
		}
	}
})

// Subscribe to store updates
store.subscribe((mutation, state) => {
	// Store the state object as a JSON string
	localStorage.setItem('store', JSON.stringify(state));
});

export default store;

function pad(num, size) {
        var s = num + "";
        while (s.length < size) s = "0" + s;
        return s;
}


// WEBPACK FOOTER //
// ./src/store/store.js